import moment from 'moment';
import CountryList from './CountryList';
import CountryExtendedList from './CountryExtendedList';
import GenderList from './GenderList';
import motiveList from './motives';
import StatesList from './StatesList';

export const isBase64 = (string) => {
  const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

  const m = base64regex.exec(string);
  let valid = false;

  if (m !== null) {
    m.forEach((match, groupIndex) => {
      if (typeof match !== 'undefined') {
        if (match > 0 || groupIndex > 0) {
          valid = true;
        }
      }
    });
  }

  return valid;
};

export const isEmptyObject = (value) => {
  if (value == null) {
    // null or undefined
    return false;
  }

  if (typeof value !== 'object') {
    // boolean, number, string, function, etc.
    return false;
  }

  const proto = Object.getPrototypeOf(value);

  // consider `Object.create(null)`, commonly used as a safe map
  // before `Map` support, an empty object as well as `{}`
  if (proto !== null && proto !== Object.prototype) {
    return false;
  }

  return Object.keys(value).length === 0;
};

export const issetProperty = (object, property) => {
  if (object === null || object === 'null') {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(object, property);
};

export const replaceDataImage = (value) => value.replace(/^data:image\/[a-z]+;base64,/, '').trim();

export const base64PuroRegex = (value) => value.replace(/^data:application\/\w+;base64,/, '').trim();

export const cleanBase64 = (value) => value.replace(/^data:(image|application)\/\w+;base64,/, '').trim();

export const stringDateToDate = (stringDate, formatter = 'DD MMM YYYY') => moment(stringDate, formatter);

export const dateFormatter = (date, formatter = 'DD MMM YYYY') => moment(date).format(formatter);

// Cambia de 12:00 pm a formato de 24 horas
export const getReturnTimeClosest = (time) => {
  const momentTime = moment(time, 'hh:mm A');
  // Redondear al intervalo de 15 minutos más cercano
  // 44 / 15 = 2.93, Math.round(2.93) = 3, 3 * 15 = 45
  // Estable los minutos = 45
  const roundedTime = momentTime.minute(Math.round(momentTime.minute() / 15) * 15).format('HH:mm');

  return roundedTime;
};

export const dateParseObject = (dateString) => {
  // Parseando la fecha en formato 'YYYYMMDDHHmmss'
  const dateMoment = moment(dateString, 'YYYYMMDDHHmmss');

  // Formateando el objeto con dia, mes y año
  const dateObject = {
    day: dateMoment.format('DD'),
    month: dateMoment.format('MMM'),
    year: dateMoment.format('YYYY'),
  };
  return dateObject;
  // console.log(fechaObjeto);
};

export const timeFormatter = (time, formatter = 'hh:mm A') => {
  // Parseando la hora en formato 'HHmmss'
  const formatted = moment(time, 'HHmmss');

  // Formateando la hora a "HH:mm A" (para obtener el formato 24 horas con AM/PM)
  const timeFormatted = formatted.format(formatter);

  return timeFormatted;
};

export const getYearsByDate = (date) => {
  // Obten la fecha actual
  const currentDate = moment();

  // Calcula la diferencia en anos
  const years = currentDate.diff(date, 'years');

  return years;
};

export const getYearsBirthByArrivalDate = (date, arrivalDate = 'YYYYMMDD', formatter = 'YYYYMMDD') => {
  // Obten la fecha actual
  // const currentDate = moment();

  // Fecha de llegada sin hora
  const arrivalDateMoment = moment(arrivalDate, formatter);

  // Calcula la diferencia en anos
  const years = arrivalDateMoment.diff(date, 'years');

  return years;
};

export const getDocumentTypeToApi = (documentType) => (documentType.toLocaleUpperCase() === 'INE' ? 4 : 2);

export const isValidDateByStringDate = (stringDate, formatter = 'YYYYMMDD') => {
  const dateObject = moment(stringDate, formatter);
  return dateObject.isValid();
};

// Validar fecha de nacimiento
export const getBithdateByStringDate = (stringDate, formatter = 'DD/MM/YY') => {
  // eslint-disable-next-line max-len
  moment.parseTwoDigitYear = (year) => (parseInt(year, 10) < 50 ? 2000 + parseInt(year, 10) : 1900 + parseInt(year, 10));
  const dateObject = moment(stringDate, formatter, true);
  if (dateObject.isValid()) {
    return dateObject.toDate();
  }
  return '';
};

// Validar fecha de caducidad
export const getExpirationDateByStringDate = (stringDate, format = 'DD/MM/YY', formatter = 'DD/MM/YYYY') => {
  // eslint-disable-next-line max-len
  moment.parseTwoDigitYear = (year) => (parseInt(year, 10) < 50 ? 2000 + parseInt(year, 10) : 1900 + parseInt(year, 10));
  // 'true' para validacion estricta
  const dateObject = moment(stringDate, format, true);

  if (!dateObject.isValid()) {
    return '';
  }

  // Fecha de hoy sin hora
  const today = moment().startOf('day');

  // Si la fecha es pasada, vacia; si es futura, la formatea
  return dateObject.isBefore(today) ? '' : dateObject.toDate();
};

// Validar fecha de expedicion
export const getExpeditionDateByStringDate = (stringDate, arrivalDate = 'YYYYMMDD', format = 'DD/MM/YY', formatter = 'YYYYMMDD') => {
  // eslint-disable-next-line max-len
  moment.parseTwoDigitYear = (year) => (parseInt(year, 10) < 50 ? 2000 + parseInt(year, 10) : 1900 + parseInt(year, 10));
  // 'true' para validacion estricta
  const dateObject = moment(stringDate, format, true);

  if (!dateObject.isValid()) {
    return '';
  }

  // Fecha de hoy sin hora
  const today = moment(arrivalDate, formatter).startOf('day');
  // console.log(today);

  // Si la fecha es futura, vacia; si es pasada, la formatea
  return dateObject.isAfter(today) ? '' : dateObject.toDate();
};

export const getDateByStringDate = (stringDate, formatter = 'YYYYMMDD') => {
  const dateObject = moment(stringDate, formatter);
  if (dateObject.isValid()) {
    return dateObject.toDate();
  }
  return '';
};

export const getStringDate = (stringDate, format = 'YYYYMMDD', formatter = 'DD/MM/YYYY') => {
  const dateObject = moment(stringDate, format);
  if (dateObject.isValid()) {
    return moment(dateObject).format(formatter);
  }
  return '';
};

export const getGenderByInt = (gender) => (parseInt(gender, 10) === 1 ? 'Hombre' : 'Mujer');

export const getGenderShortByInt = (gender) => (parseInt(gender, 10) === 1 ? 'H' : 'M');

export const getGenderToApi = (gender) => (gender.toLocaleUpperCase() === 'HOMBRE' ? 1 : 2);

export const getGenderShortToApi = (gender) => (gender.toLocaleUpperCase() === 'H' ? 1 : 2);

export const getDocumentTypeByInt = (documentType) => (parseInt(documentType, 10) === 4 ? 'INE' : 'PASSPORT');

export const getPersonTypeByInt = (personType) => {
  const personTypes = [
    { id: '1', tipo: 'Adulto', tagKey: 'AD' },
    { id: '2', tipo: 'Junior', tagkey: 'JR' },
    { id: '3', tipo: 'Niño', tagkey: 'NI' },
    { id: '4', tipo: 'Bebé', tagkey: 'CU' },
  ];

  const person = personTypes.find((item) => item.id === personType);

  return person || { id: '', tipo: '', tagkey: '' };
};

export const getCountryByCode = (countryCode) => {
  let objectCountry = {};
  if (CountryExtendedList.length > 0) {
    for (let index = 0; index < CountryExtendedList.length; index++) {
      const element = CountryExtendedList[index];
      if (element.iso2 === countryCode) {
        objectCountry = element;
        break;
      }
    }
  }
  return objectCountry;
};

export const getStateResidenByCode = (stateCode) => {
  let dataState = {};
  if (StatesList.length > 0) {
    for (let index = 0; index < StatesList.length; index++) {
      const element = StatesList[index];
      if (element.iso2State === stateCode) {
        dataState = element;
        break;
      }
    }
  }
  return dataState;
};

export const getSexByCode = (sexCode) => {
  let objectCountry = { Code: '', NameEN: '', NameES: '' };
  if (GenderList.length > 0) {
    for (let index = 0; index < GenderList.length; index++) {
      const element = GenderList[index];
      if (element.Code === sexCode) {
        objectCountry = element;
        break;
      }
    }
  }
  return objectCountry;
};

export const verifyGuestTypeByAge = (customBirthDate) => {
  // Tipo de pasajero
  let dataGuestType = {};
  const yearAge = parseInt(customBirthDate, 10);
  if (yearAge < 2) {
    dataGuestType = { id: '4', tipo: 'Bebé', tagkey: 'CU' };
  } else if (yearAge >= 2 && yearAge <= 12) {
    dataGuestType = { id: '3', tipo: 'Niño', tagkey: 'NI' };
  } else if (yearAge >= 13 && yearAge <= 17) {
    dataGuestType = { id: '2', tipo: 'Junior', tagkey: 'JR' };
  } else {
    dataGuestType = { id: '1', tipo: 'Adulto', tagkey: 'AD' };
  }

  return dataGuestType;
};

export const verifyGuestTypeByAB = (arrivalDate, birthDate) => {
  const formatoLlegada = 'YYYYMMDDHHmmss';
  const formatoNacimiento = 'DD/MM/YYYY';

  // echas a objetos moment
  const fechaEntradaMoment = moment(arrivalDate, formatoLlegada);
  const fechaNacimientoMoment = moment(birthDate, formatoNacimiento);

  const yearAge = fechaEntradaMoment.diff(fechaNacimientoMoment, 'years');

  // Tipo de pasajero
  let dataGuestType = '';
  if (yearAge < 2) {
    dataGuestType = { id: '4', tipo: 'Bebé' };
  } else if (yearAge >= 2 && yearAge <= 12) {
    dataGuestType = { id: '3', tipo: 'Niño' };
  } else if (yearAge >= 13 && yearAge <= 16) {
    dataGuestType = { id: '2', tipo: 'Junior' };
  } else {
    dataGuestType = { id: '1', tipo: 'Adulto' };
  }

  return { yearAge, ...dataGuestType };
};

export const getDataCountryByIso3 = (countryCode) => {
  let objectCountry = { nameES: '', nameEN: '', iso2: '', iso3: '', phoneCode: '' };
  if (CountryExtendedList.length > 0) {
    for (let index = 0; index < CountryExtendedList.length; index++) {
      const element = CountryExtendedList[index];
      if (element.iso3 === countryCode) {
        objectCountry = element;
        break;
      }
    }
  }
  return objectCountry;
};

export const clearCustomFormatter = (data) => {
  const dataObject = { ...data };
  delete dataObject.FormatterFechaCaducidad;
  delete dataObject.FormatterFechaEntrada;
  delete dataObject.FormatterFechaExpedicion;
  delete dataObject.FormatterFechaNacimiento;
  delete dataObject.FormatterFechaSalida;
  delete dataObject.FormatterSexo;
  delete dataObject.customId;
  delete dataObject.customNumber;
  delete dataObject.FormatterSexoShort;
  delete dataObject.FormatterTipoDocumento;

  return dataObject;
};

export const allowZipCodeByCountry = (country) => {
  const allowList = ['MEX', 'DOM'];
  return allowList.includes(country.iso3);
};

export const allowStateResidenceByCountry = (country) => {
  const allowList = ['CAN', 'USA'];
  return allowList.includes(country.iso3);
};

export const getBookingMotiveByName = (motiveName) => {
  let dataMotive = {};
  for (let index = 0; index < motiveList.length; index = +1) {
    const element = motiveList[index];
    if (element.MotiveName.toLocaleUpperCase() === motiveName.toLocaleUpperCase()) {
      dataMotive = element;
    }
  }
  return dataMotive;
};

export const generateCustomId = () => {
  const array = new Uint32Array(1); // Crear un array de un valor
  crypto.getRandomValues(array); // Llenar el array con valores aleatorios
  return array[0].toString(10); // Convertir el valor aleatorio a cadena en base 10
};
